import React from 'react';
import MarkdownPage from './MarkdownPage';

export default function TermsOfService() {
  return <MarkdownPage file="terms-of-service.md" />;
}
